import { VOICEMAILS_VIEW_ID } from 'calling-orchestration-shared-library/call-index-page/constants/viewConstants';

// https://git.hubteam.com/HubSpot/Sales/blob/master/SalesCore/src/main/protobuf/sales.proto#L22-40
export const ALL = 'all';
export const MY = 'my';
export const UNASSIGNED = 'unassigned';
export const RECORDED_CALLS = 'recorded_calls';
export const FORECAST = 'forecast';
export const VOICEMAILS = VOICEMAILS_VIEW_ID;